export default __webpack_public_path__ + "static/media/telegramicon.64e8603d.png";